// extracted by mini-css-extract-plugin
module.exports = {"main":"_8Z6my"};